<template>
	<div class="account-details-wrapper">
    <div class="account-details">
      <div class="account-details-header">
        <h2>Account Details</h2>
        <span class="edit-account" @click="editAccount">Edit</span>
        <span class="account-alert">Click again to save</span>
      </div>
      <form action="#" method="POST">
        <div class="general-details">
          <div class="form-group">
            <label>Email Address</label>
            <input type="password" placeholder="johnsmith@example.com" v-model="loggedInUser.email" disabled autocomplete="off"/>
          </div>
          <div class="form-group">
            <label>Full Name</label>
            <input type="password" placeholder="John Smith" v-model="loggedInUser.displayName" disabled autocomplete="off"/>
          </div>
          <!-- <div class="form-group input-password">
            <label>Password</label>
            <input type="password" placeholder="12345678" id="password-input" v-model="user.pw" disabled/>
            <button type="button" @click="showPassword">
              <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33929 7.4775C7.33929 8.15883 7.60995 8.81225 8.09172 9.29402C8.57349 9.7758 9.22692 10.0465 9.90825 10.0465C10.5896 10.0465 11.243 9.7758 11.7248 9.29402C12.2065 8.81225 12.4772 8.15883 12.4772 7.4775C12.4772 6.79617 12.2065 6.14274 11.7248 5.66097C11.243 5.1792 10.5896 4.90854 9.90825 4.90854C9.22692 4.90854 8.57349 5.1792 8.09172 5.66097C7.60995 6.14274 7.33929 6.79617 7.33929 7.4775ZM19.8675 6.88572C17.6931 2.30518 14.4062 0 9.99999 0C5.59148 0 2.30689 2.30518 0.132451 6.88801C0.0452335 7.0727 0 7.2744 0 7.47864C0 7.68289 0.0452335 7.88459 0.132451 8.06927C2.30689 12.6498 5.59378 14.955 9.99999 14.955C14.4085 14.955 17.6931 12.6498 19.8675 8.06698C20.0442 7.6954 20.0442 7.26418 19.8675 6.88572ZM9.90825 11.5144C7.67876 11.5144 5.87132 9.70698 5.87132 7.4775C5.87132 5.24801 7.67876 3.44057 9.90825 3.44057C12.1377 3.44057 13.9452 5.24801 13.9452 7.4775C13.9452 9.70698 12.1377 11.5144 9.90825 11.5144Z" fill="#FCAF05"/>
              </svg>
            </button>
          </div> -->
          <div class="form-group">
            <label>Company</label>
            <input type="password" placeholder="John Smith Inc." v-model="loggedInUser.company" disabled autocomplete="off"/>
          </div>
        </div>
        <div class="payment-details">
          <div class="payment-header">
            <h2>Payment Methods</h2>
            <a @click="addNewPaymentMethod(loggedInUser.tier)" :class="{canAddPayment:loggedInUser.tier=='FOUNDER'}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 7.5L15 7.5" stroke="#676868" stroke-width="2"/>
                <path d="M7.5 0L7.5 15" stroke="#676868" stroke-width="2"/>
              </svg>
              <span>Add New Method</span>
            </a>
          </div>
          <table class="payment-table">
            <thead>
              <tr>
                <td>Card Holder Name</td>
                <td>Card Number</td>
                <td>Expiry Date</td>
                <td>CVC</td>
                <td>Action</td>
              </tr>
            </thead>
            <!-- if no payment info -->
            <p class="upgrade-plan-info" v-if='false'>To add payment method you have to <router-link to="/pricing-plan" class="upgrade-plan"><a>upgrade your plan</a></router-link> .</p>
            <!-- end of if no payment -->
            <tbody>
              <tr v-for="payment in cards" :key='payment.id'>
                <td>
                  <label class="custom-check">
                    <input type="radio" name="paymentId"/>
                    <span class="checkmark"></span>
                  </label>
                  <p class="custom-check-name">{{payment.billing_details.name}}</p>
                </td>
                <td>xxxx xxxx xxxx {{payment.card.last4}}</td>
                <td> <span>{{formatExpiration(payment.card.exp_month, payment.card.exp_year)}}</span> </td>
                <td>xxx</td>
                <td>
                  <svg @click="openDeleteModal(payment)" width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="35" height="35" rx="5" fill="#FFDDDD"/>
                    <path d="M24.5 11H20.75L20.4563 10.4156C20.394 10.2907 20.2982 10.1856 20.1795 10.1122C20.0608 10.0388 19.9239 9.99991 19.7844 10H16.2125C16.0732 9.99947 15.9367 10.0382 15.8184 10.1117C15.7001 10.1852 15.6049 10.2905 15.5437 10.4156L15.25 11H11.5C11.3674 11 11.2402 11.0527 11.1464 11.1465C11.0527 11.2402 11 11.3674 11 11.5V12.5C11 12.6326 11.0527 12.7598 11.1464 12.8536C11.2402 12.9473 11.3674 13 11.5 13H24.5C24.6326 13 24.7598 12.9473 24.8536 12.8536C24.9473 12.7598 25 12.6326 25 12.5V11.5C25 11.3674 24.9473 11.2402 24.8536 11.1465C24.7598 11.0527 24.6326 11 24.5 11ZM12.6625 24.5938C12.6863 24.9746 12.8544 25.332 13.1325 25.5932C13.4106 25.8545 13.7778 26 14.1594 26H21.8406C22.2222 26 22.5894 25.8545 22.8675 25.5932C23.1456 25.332 23.3137 24.9746 23.3375 24.5938L24 14H12L12.6625 24.5938Z" fill="#F26464"/>
                  </svg>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="account-plan">
          <h2>Plan</h2>
          <PremiumUserPlan 
            v-if="loggedInUser.tier=='FOUNDER'"
            :user='loggedInUser'
          />
          <FreeUserPlan 
            v-if='loggedInUser.tier=="FREE"'
            :user='loggedInUser'
          />
        </div>
      </form>
    </div>
    <StripeModal/>
    <DeleteModal
      @deleted='deleteCard'
    />
	</div>
</template>

<script>
import PremiumUserPlan from '@/components/user/account/plan-premium-user.vue';
import FreeUserPlan from '@/components/user/account/plan-free-user.vue';
import StripeModal from '@/components/user/modals/stripe-modal.vue';
import DeleteModal from '@/components/user/modals/delete.vue';

import {axiosClient} from "@/axios-client";

export default {
  name: 'account-details',

  props: ['loggedInUser'],

  data() {
    return {
      currentUser: null,

      visibilityCounter: 0,

      cards: [],

      cardToDelete: null,
    }
  },

  components: {
    PremiumUserPlan,
    FreeUserPlan,
    StripeModal,
    DeleteModal
  },

  created() {
    axiosClient.get('/v1/stripe/credit-card-details')
      .then((res) => {
        this.cards = res.data.data;
      });
    axiosClient.get('v1/account')
      .then((response) => {
        this.currentUser = response.data;
    });
  },

  methods: {
    // showPassword() {
    //   let input = document.querySelector('#password-input');
    //   input.getAttribute('type') == 'password' ? input.setAttribute('type', 'text') : input.setAttribute('type', 'password');
    // },

    editAccount() {
      this.visibilityCounter++;

      console.log(this.currentUser);

      let inputs = document.querySelectorAll('.general-details input');
      let msg = document.querySelector('span.account-alert');

      for(let input of inputs) {
        input.toggleAttribute('disabled');

        if(this.visibilityCounter % 2 != 0) {
          input.setAttribute('type', 'text');
          msg.style.display = 'block';
        } else {
          input.setAttribute('type', 'password');
          msg.style.display = 'none';
        }
      }

      if(this.visibilityCounter % 2 == 0) {
        axiosClient.patch('/v1/account', {
          "displayName": this.loggedInUser.displayName,
          "jobTitle": this.loggedInUser.jobTitle,
          "company": this.loggedInUser.company,
          "email": this.loggedInUser.email
        })
          .then(() => { this.$emit('updated') })
          .catch(() => { this.$emit('error')});
      }
    },

    openDeleteModal(card) {
      document.querySelector('.delete-modal-wrapper').style.opacity = '1';
      document.querySelector('.delete-modal-wrapper').style.zIndex = '999';
      document.querySelector('.delete-modal-wrapper').classList.add('isModalOpen');
      document.querySelector('body').style.overflow = 'hidden';
      this.cardToDelete = card.id;
      // this.$emit('deleteCard', card.id);
    },

    deleteCard() {
      let id = this.cardToDelete;
      axiosClient.delete('/v1/stripe/delete-payment-method/' + id)
        .then(this.updateAfterDelete);
    },

    updateAfterDelete() {
      axiosClient.get('/v1/stripe/credit-card-details')
        .then((res) => {
          this.cards = res.data.data;
        });
    },

    addNewPaymentMethod(isUserPremium) {
      if(isUserPremium != 'FREE') {
				document.querySelector('.stripe-modal-wrapper').style.opacity = '1';
				document.querySelector('.stripe-modal-wrapper').style.zIndex = '999';
				document.querySelector('.stripe-modal-wrapper').classList.add('isModalOpen');
				document.querySelector('body').style.overflow = 'hidden';
      }
    },

    formatExpiration(month, year) {
      if(month < 10) {
        month = '0' + month;
      }

      year = year.toString().slice(2,4);

      return month + '/' + year;
    }

    // editStripePayment() {
    //   document.querySelector('.stripe-modal-wrapper').style.opacity = '1';
    //   document.querySelector('.stripe-modal-wrapper').style.zIndex = '999';
    //   document.querySelector('.stripe-modal-wrapper').classList.add('isModalOpen');
    //   document.querySelector('body').style.overflow = 'hidden';
    // }
  }
}
</script>

<style lang="scss">
	.account-details-wrapper {
    width: 100%;
    padding: 50px 0;

    h2 {
      font-family: "Roboto-Medium";
      font-size: 26px;
      line-height: 24px;
      margin: 0 22px 0 0;
    }

    .account-details-header {
      display: flex;
      align-items: flex-end;
      margin-bottom: 30px;
      padding: 0 50px;
  
      .edit-account {
        font-size: 16px;
        line-height: 15px;
        color: #FCAF05;
        cursor: pointer;
        margin-bottom: 3px;
        margin-right: 15px;
      }

      span.account-alert {
        color: #858585;
        font-size: 14px;
        display: none;
      }
    }

    form {
      .general-details {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ededed;
        padding: 0 50px 25px 50px;

        .form-group {
          display: flex;
          flex-direction: column;
          width: 28%;
          margin: 0;

          label {
            font-size: 14px;
            line-height: 31px;
            font-family: "Gotham-Book";
            margin: 0;
            color: #676868;
          }

          &:first-of-type {
            width: 40%; //33
          }

          input {
            border: 1px solid #CDCDCD;
            border-radius: 5px;
            padding: 12px 20px;
            color: #303030;
            font-size: 14px;

            &::placeholder {
              color: #303030;
            }

            &:focus {
              outline: none;

              &::placeholder {
                color: transparent;
              }
            }
          }

          &.input-password {
            position: relative;

            input {
              padding-right: 35px;
            }

            button {
              position: absolute;
              right: 10px;
              bottom: 13px;
              background: none;
              border: none;
              z-index: 200;

              &:focus {
                outline: none;
              }
            }
          }
        }
      }

      .payment-details {
        padding: 45px 50px;
        border-bottom: 1px solid #ededed;

        .payment-header {
          display: flex;
          align-items: center;
          

          a {
            display: flex;
            align-items: center;
            color: #676868;
            font-family: "Gotham-Medium";
            cursor: pointer;

            svg {
              margin-right: 15px;
              margin-bottom: 3px;
            }

            &.canAddPayment {
              color: #FCAF05;

              svg path {
                stroke: #FCAF05;
              }
            }
          }
        }

        .payment-table {
          width: 100%;

          .upgrade-plan-info {
            margin: 20px 0;
            .upgrade-plan {
              a {
                display: inline;
                color: #FCAF05;
              }
            }
          }

          thead {
            border-bottom: 1px solid #EDEDED;

            td {
              padding: 45px 0 17px;
              font-family: "Gotham-Medium";

              &:last-of-type {
                text-align: right;
              }
            }
          }

          tbody {
            tr {
              border-bottom: 1px solid #ededed;

              &:last-of-type {
                border-bottom: none;
              }

              td {
                &:last-of-type {
                  text-align: right;

                  svg {
                    cursor: pointer;
                    &:last-of-type {
                      margin-left: 14px;
                    }
                  }
                }

                .custom-check-name {
                  margin: 0;
                  padding-left: 35px;
                }

                .checkmark {
                  top: 4px;
                }

                padding: 24px 0;
              }
            }
          }
        }
      }

      .account-plan {
        padding: 40px 50px 0 50px;

        h2 {
          margin-bottom: 20px;
        }
      }
    }

  }
</style>